var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loadingStatus)?_c('div',{staticClass:"loading-overlay",attrs:{"id":"loading-screen"}},[_c('b-spinner',{staticClass:"loading-spinner",attrs:{"variant":_vm.spinnerColor,"id":"loading-screen-spinner","label":"Loading"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }